import { useDownloadPathwayPdf } from "@pages/journey-map/api/use-download-pathway-pdf";
import { saveAs } from "file-saver";

import { useAuth } from "@hooks/use-auth";
import { formatDate } from "@lib/date.helpers";
import { PathwaysCard } from "./components/pathways.card";

import { Loader, ToastType } from "@features/ui";
import { useToast } from "@hooks/use-toast";
import "./index.scss";

export const PathwaysPage = () => {
  const { user } = useAuth();
  const { setToast } = useToast();

  const { mutateAsync: requestPdf, isPending: isDownloadingPdf } =
    useDownloadPathwayPdf();

  const onDownloadCareerPlan = async (careerPlan) => {
    await requestPdf(careerPlan.id, {
      onSuccess: (pdfBlob) => {
        const { firstName, lastName } = user;
        saveAs(
          pdfBlob,
          `Transfr Trek Pathway - ${firstName} ${lastName} - ${formatDate()}`,
        );
      },
      onError: () => {
        setToast({
          message: "Error generating PDF. Please try again.",
          type: ToastType.error,
        });
      },
    });
  };

  return (
    <div className="pathways-page">
      <Loader show={isDownloadingPdf} text="Generating PDF..." />
      <PathwaysCard
        onDownloadClicked={onDownloadCareerPlan}
        onError={setToast}
      />
    </div>
  );
};
